// auto-generated
export const SDK_NAME = "@friskai/frisk-js" as const;
export const SDK_VERSION = "0.3.2" as const;
